import { useModal } from "@/Contexts";
import { trpc } from "@/Utils/trpc";
import ModalContainer from "@/components/modalContainer";
import { useTrans } from "@/translations";

import { useState } from "react";

import { useAccessPoints } from "../manage/useAccessPoints";

export const DeleteContainerModal: React.FC<{
  containerId: string;
  accessParentId: string;
  containerName: string | undefined;
  onSuccess?: () => void;
}> = ({ accessParentId, containerId, containerName, onSuccess }) => {
  const [isLoading, setLoading] = useState(false);

  const { t } = useTrans();
  const { hideModal } = useModal();
  const { refetchAll } = useAccessPoints({ accessParentId });
  const { mutateAsync: deletePoint } = trpc.accessPoints.delete.useMutation();

  const onFailCallBack = () => {
    setLoading(false);
  };

  const onSuccessCallback = () => {
    refetchAll();
    onSuccess?.();
    hideModal();
  };

  const onConfirm = () => {
    setLoading(true);

    deletePoint(
      { id: containerId },
      {
        onSuccess: onSuccessCallback,
        onError: onFailCallBack,
      },
    );
  };

  return (
    <ModalContainer
      title={"actions:deleteContainer"}
      onConfirmText={"actions:confirm"}
      onConfirm={onConfirm}
      onCancel={hideModal}
      onConfirmLoading={isLoading}
      onConfirmDisabled={isLoading}
    >
      <div className="pt-3">
        <p>
          {t("hints:areYouSureDelete", {
            name: containerName || t("entities:container").toLowerCase(),
          })}
        </p>
      </div>
    </ModalContainer>
  );
};
